import { OwcButton } from "@one/react";
import { Variant } from "@one/web-components";
import { useFormikContext } from "formik";
import { react18WorkaroundProps } from "../../../constants/react18WorkaroundProps";

type Props = {
  confirmText?: string;
  confirmButtonVariant: Variant;
};

export const FormSubmitButton = ({ confirmButtonVariant, confirmText = "OK" }: Props) => {
  const { validateForm, setTouched, submitForm } = useFormikContext();
  return (
    <OwcButton
      {...react18WorkaroundProps}
      style={{ margin: 2 }}
      variant={confirmButtonVariant}
      onClick={async (e: React.MouseEvent<HTMLOwcButtonElement>) => {
        const errors = await validateForm();

        if (Object.keys(errors).length > 0) {
          // If there are validation errors, mark all fields as touched
          setTouched(
            Object.keys(errors).reduce((acc, key) => {
              acc[key] = true;
              return acc;
            }, {} as Record<string, boolean>)
          );
        } else {
          // If no validation errors, proceed with form submission
          submitForm();
        }
      }}
    >
      {confirmText}
    </OwcButton>
  );
};
